(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sauna-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__spcBound) return;
    window.__spcBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-spc-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var label = btn.querySelector('[data-spc-label]');
      var original = label ? label.textContent : '';
      btn.disabled = true;
      if (label) label.textContent = btn.dataset.adding || '...';
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] }),
      })
        .then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok) throw new Error(d.description || d.message || 'Error');
            return d;
          });
        })
        .then(function () {
          if (label) label.textContent = btn.dataset.added || 'Added';
          document.dispatchEvent(new CustomEvent('sauna:cart:changed', { bubbles: true, detail: { source: 'card' } }));
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        })
        .catch(function (err) {
          window.alert(err.message);
        })
        .then(function () {
          setTimeout(function () {
            btn.disabled = false;
            if (label) label.textContent = original;
          }, 1500);
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sauna-shop-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__sscBound) return;
    window.__sscBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ssc-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;
      var label = btn.querySelector('[data-ssc-label]');
      var original = label ? label.textContent : '';
      btn.disabled = true;
      if (label) label.textContent = btn.dataset.adding || '...';
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] }),
      })
        .then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok) throw new Error(d.description || d.message || 'Error');
            return d;
          });
        })
        .then(function () {
          if (label) label.textContent = btn.dataset.added || 'Added';
          document.dispatchEvent(new CustomEvent('sauna:cart:changed', { bubbles: true, detail: { source: 'card' } }));
          ['theme:cart:refresh', 'cart:refresh', 'cart:build'].forEach(function (name) {
            document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
          });
        })
        .catch(function (err) {
          window.alert(err.message);
        })
        .then(function () {
          setTimeout(function () {
            btn.disabled = false;
            if (label) label.textContent = original;
          }, 1500);
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
